import { render, staticRenderFns } from "./LiveAppRoomRedirect.vue?vue&type=template&id=7493aa22"
import script from "./LiveAppRoomRedirect.vue?vue&type=script&lang=ts"
export * from "./LiveAppRoomRedirect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports